import { match } from 'ts-pattern';

import type { TelehealthSettingsValue } from '@/entities/practice-member-settings';

// The design's own copy for the per-appointment editing alert, reused verbatim as the saved caption.
export const PER_APPOINTMENT_SUMMARY_CAPTION =
    "We don't have telehealth integrations just yet, so you'll add each appointment link as you schedule";

export type TelehealthLinkRowSummary = {
    caption: string;
    instructions: string | null;
    actionLabel: 'Add' | 'Edit';
};

export function getTelehealthLinkRowSummary(
    settings: TelehealthSettingsValue,
): TelehealthLinkRowSummary {
    return match(settings.linkType)
        .returnType<TelehealthLinkRowSummary>()
        .with(null, () => ({ caption: 'None provided', instructions: null, actionLabel: 'Add' }))
        .with('SAME_FOR_ALL', () => ({
            caption: settings.link ?? '',
            instructions: settings.instructions ?? null,
            actionLabel: 'Edit',
        }))
        .with('PER_APPOINTMENT', () => ({
            caption: PER_APPOINTMENT_SUMMARY_CAPTION,
            instructions: null,
            actionLabel: 'Edit',
        }))
        .exhaustive();
}
